/**
 * @file
 */

import { CurrentPhase } from "@/common/common.js";

/*-----------------popup-----------------*/
export function InitializeAdditionalResourcesPage() {
  $("#divMofelpDialog").dialog({
    modal: true,
    autoOpen: false,
    title: "Informational Message:",
    width: 560,
    buttons: [
      {
        id: "btnOK",
        text: "OK",
        click: function () {
          var href = $(this).dialog("option", "href");
          window.open(href,"_blank");
          $(this).dialog('close');
        }
      },
      {
        id: "btnCancel",
        text: "Cancel",
        click: function () {
          $(this).dialog('close');
        }
      }
    ]
  });

  function mslfURL() {
    var phase = CurrentPhase();
    if (phase.indexOf("DEV") !== -1) {
      return 'https://mylocalhostmslf.mohela.com';
    } else if (phase.indexOf("TEST") !== -1) {
      return 'https://testingmslf.mohela.com';
    } else if (phase.indexOf("STAGING") !== -1) {
      return 'https://stagingmslf.mohela.com';
    } else {
      return 'https://mslf.mohela.com';
    }
  }

  $("#aMOFELPApplication").click(function (e) {
    $('#divMofelpDialog').dialog("option", "href", mslfURL() + "/DL/secure/borrower/findFormList.aspx");
    $('#divMofelpDialog').dialog('open');
  });

  $("#aMOFELPAutoDebit").click(function (e) {
    $('#divMofelpDialog').dialog("option", "href", mslfURL() + "/DL/secure/borrower/findFormList.aspx");
    $('#divMofelpDialog').dialog('open');
  });

  $("#aMOFELPPrivacyPolicy").click(function (e) {
    $('#divMofelpDialog').dialog("option", "href", mslfURL() + "/DL/common/privacy/internetPrivacy.aspx");
    $('#divMofelpDialog').dialog('open');
  });

  $("#aMOFELPHomePage").click(function (e) {
    $('#divMofelpDialog').dialog("option", "href", mslfURL() + "/");
    $('#divMofelpDialog').dialog('open');
  });

  $("#aMOFELPDesignation").click(function (e) {
    $('#divMofelpDialog').dialog("option", "href", mslfURL() + "/DL/secure/borrower/findFormList.aspx");
    $('#divMofelpDialog').dialog('open');
  });

};
